import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  theme,
} from "@aksara-ui/react";
import React from "react";
import { TierRewardsTabsContent } from "./components";

interface Props {
  tierName?: string | undefined;
}

const TierRewardsContent: React.FC<Props> = ({ tierName }) => {
  return (
    <Box>
      <Tabs>
        <TabList
          backgroundColor={"white"}
          borderBottom={`1px solid ${theme.colors.grey03}`}
          style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 20 }}
        >
          <Tab>Physical Goods</Tab>
          <Tab>Digital Goods</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <TierRewardsTabsContent tierName={tierName} type="Catalog" />
          </TabPanel>
          <TabPanel>
            <TierRewardsTabsContent tierName={tierName} type="Voucher" />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default TierRewardsContent;
